export default __webpack_public_path__ + "static/media/Chart.3c8d50ee.svg";